@use '@lib/assets/styles/main.scss' as *;

.loaderWrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: $zIndexLoader;
  background-color: $gray0;
}

.loaderLogo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: auto;
  z-index: 1;
}

.loaderVideo {
  width: 300px;
  height: auto;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  outline: none;
  box-shadow: none;
  &::-webkit-media-controls-start-playback-button { display: none; }
  &::-webkit-media-controls { display: none !important; }
}
